// extracted by css-extract-rspack-plugin
export default {"titleNumber":"SubIssueTitle-module__titleNumber__ajDqJ","titleAnchor":"SubIssueTitle-module__titleAnchor__wUgEs"};